import React from 'react';
import { ChevronRight } from 'lucide-react';
import './ig-liste.css';
import { avecLogos } from '../BrandLogos';

/* Liste groupée façon Réglages iOS / Instagram : titre gris en capitales, carte blanche, lignes à filets, chevron ou interrupteur. */

export const IgGroupe = ({ titre, note, children, testId }) => (
  <section className="ig-groupe" data-testid={testId}>
    {titre && <p className="ig-groupe-t">{titre}</p>}
    <div className="ig-groupe-c">{children}</div>
    {note && <p className="ig-groupe-n">{note}</p>}
  </section>
);

export const IgSwitch = ({ checked, onChange, disabled, testId, label }) => (
  <button type="button" role="switch" aria-checked={!!checked} aria-label={label} disabled={disabled} onClick={(e) => { e.stopPropagation(); onChange(!checked); }} className={`ig-switch ${checked ? 'is-on' : ''}`} data-testid={testId} data-keepicon=""><i /></button>
);

export const IgLigne = ({ icone, iconeBg, avatar, label, sous, valeur, tone, dot, onClick, href, chevron, interrupteur, enfant, disabled, testId }) => {
  const Tag = href ? 'a' : onClick ? 'button' : 'div';
  const cliquable = !!(onClick || href);
  return (
    <Tag type={Tag === 'button' ? 'button' : undefined} href={href} onClick={onClick} disabled={disabled} className={`ig-ligne ${cliquable ? 'is-click' : ''} ${enfant ? 'has-enfant' : ''}`} data-testid={testId} data-keepicon="">
      {avatar ? <span className="ig-ligne-av">{avatar}</span> : icone ? <span className="ig-ligne-ico" style={iconeBg ? { background: iconeBg, color: '#fff' } : undefined}>{icone}</span> : null}
      <span className="ig-ligne-txt">
        <span className="ig-ligne-l">{dot && <i className={`ig-ligne-dot is-${dot}`} />}{avecLogos(label)}</span>
        {sous && <span className="ig-ligne-s">{avecLogos(sous, 13)}</span>}
        {enfant && <span className="ig-ligne-enfant">{enfant}</span>}
      </span>
      {valeur != null && valeur !== '' && <span className={`ig-ligne-v ${tone ? `tone-${tone}` : ''}`} data-testid={testId ? `${testId}-valeur` : undefined}>{avecLogos(valeur, 14)}</span>}
      {interrupteur ? <IgSwitch {...interrupteur} label={label} testId={testId ? `${testId}-switch` : undefined} /> : (chevron ?? cliquable) ? <ChevronRight size={18} className="ig-ligne-chev" aria-hidden /> : null}
    </Tag>
  );
};
